import { splitWords, observeSplitReveal } from '../../assets/js/utils/splitWords'

export default class TitleText {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const subtitle = this.el.querySelector('.title-text--subtitle')
    const title = this.el.querySelector('.title-text--title')

    let offset = 0
    if (subtitle) {
      splitWords(subtitle, offset)
      offset += subtitle.querySelectorAll('.tt-word').length
    }
    if (title) splitWords(title, offset)

    observeSplitReveal(this.el)
  }
}
